import { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Outlet } from 'react-router'

import * as Sentry from '@sentry/react'

import { useApplicationStore } from 'app/application/infrastructure'
import { useConnections } from 'app/connections/application'
import { useObjectives } from 'app/objectives/application'
import { useSignals } from 'app/signals/application'

import { Breadcrumb } from 'components'

import { ErrorPage } from '../ErrorPage'
import { Sidebar } from '../Sidebar'
import styles from './Page.module.scss'
import useBreadcrumbPaths from './useBreadcrumbPaths'

const Page = () => {
  const workspaceId = useApplicationStore((state) => state.workspace?.id ?? state.user?.workspace?.id)
  const { fetchConnections } = useConnections()
  const { fetchObjectives } = useObjectives()
  const { fetchSignals } = useSignals()
  const breadcrumbPaths = useBreadcrumbPaths()

  useEffect(() => {
    const fetchData = async () => {
      await fetchConnections()
      await fetchObjectives()
      await fetchSignals()
    }

    void fetchData()
  }, [fetchConnections, fetchObjectives, fetchSignals, workspaceId])

  return (
    <div className={styles.page}>
      <Sidebar />
      <main className={styles.main}>
        <Breadcrumb className={styles.breadcrumb} paths={breadcrumbPaths} />
        <div className={styles.content}>
          <ErrorBoundary
            FallbackComponent={ErrorPage}
            onError={(error) => Sentry.captureException(error)}
          >
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
    </div>
  )
}

export default Page
